import { buildModelManager } from "../builder.js";
const DefaultFailedHttpCallsSelection = {
  __typename: true,
  id: true,
  apiActionName: true,
  createdAt: true,
  groupedRetryAction: true,
  method: true,
  path: true,
  payload: true,
  retryAt: true,
  updatedAt: true
};
const modelApiIdentifier = "failedHttpCalls";
const pluralModelApiIdentifier = "failedHttpCallss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFailedHttpCallsSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createFailedHttpCalls",
    operationReturnType: "CreateFailedHttpCalls",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      failedHttpCalls: { required: false, type: "CreateFailedHttpCallsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFailedHttpCallsSelection
  },
  {
    type: "action",
    operationName: "bulkCreateFailedHttpCalls",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateFailedHttpCallsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFailedHttpCallsSelection
  },
  {
    type: "action",
    operationName: "updateFailedHttpCalls",
    operationReturnType: "UpdateFailedHttpCalls",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      failedHttpCalls: { required: false, type: "UpdateFailedHttpCallsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFailedHttpCallsSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateFailedHttpCalls",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateFailedHttpCallsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultFailedHttpCallsSelection
  },
  {
    type: "action",
    operationName: "deleteFailedHttpCalls",
    operationReturnType: "DeleteFailedHttpCalls",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteFailedHttpCalls",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertFailedHttpCalls",
    operationReturnType: "UpsertFailedHttpCalls",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      failedHttpCalls: { required: false, type: "UpsertFailedHttpCallsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateFailedHttpCallsResult": { hasReturnType: false },
      "... on UpdateFailedHttpCallsResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFailedHttpCallsSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertFailedHttpCalls",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertFailedHttpCallsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultFailedHttpCallsSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "failedHttpCallsGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const FailedHttpCallsManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultFailedHttpCallsSelection,
  operations
);
export {
  DefaultFailedHttpCallsSelection,
  FailedHttpCallsManager
};
//# sourceMappingURL=FailedHttpCalls.js.map
